module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/inspiration-elite.c978a4bf.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/inspiration-elite.png
// module id = 3721
// module chunks = 11